import { connect } from 'react-redux';

import TecentConfig from '../../components/sider/tecentConfig';

export default connect()(TecentConfig);



// WEBPACK FOOTER //
// ./containers/sider/tecentConfig.js